import { useAppState } from "./useReduxState"

export const useExplanationModal = () => {
    return useAppState(state => state.client.routeInfo.explanationModal)
}
